import { SnackState } from './snackTypes';
import { createReducer } from '@reduxjs/toolkit';
import { showSnack, hideSnack } from './snackActions';

export const initialState: SnackState = {
  mensagem: '',
  tipo: 'info',
  show: false
};

const frotaReducer = createReducer(initialState, {
  [showSnack.toString()]: (state, action) => {
    if (showSnack.match(action)) {
      return { ...state, ...action.payload };
    }
    return { ...state };
  },
  [hideSnack.toString()]: (state, action) => {
    return { ...state, show: false };
  }
});

export default frotaReducer;
